module.exports = __webpack_public_path__ + "media/components/src/assets/images/icons/icon-christmas-984c28baa2086c4e3f8621c7fe69ed3f.png";